import type {ReactElement} from 'react';
import {useRef} from 'react';
import {useTopBottomScrollShadow} from '@Hooks/useTopBottomScrollShadow';
import {SurveyFieldKind} from '@Components/ai-chat-window/components/survey/survey.types';
import type {FieldRendererProps} from './fields.types';
import {TextFieldRenderer} from './text-field';
import {SelectFieldRenderer} from './select-field';
import {MultiSelectFieldRenderer} from './multiselect-field';
import styles from './fields.module.scss';

export function FieldRenderer({step}: FieldRendererProps): ReactElement | null {
  const name = step.key;
  const scrollRef = useRef<HTMLDivElement>(null);
  const {topShadow, bottomShadow} = useTopBottomScrollShadow(scrollRef);
  const field = renderField();

  function renderField(): ReactElement | null {
    switch (step.field.kind) {
      case SurveyFieldKind.TEXT:
        return <TextFieldRenderer name={name} step={step} field={step.field} />;
      case SurveyFieldKind.SELECT:
        return <SelectFieldRenderer name={name} step={step} field={step.field} />;
      case SurveyFieldKind.MULTISELECT:
        return <MultiSelectFieldRenderer name={name} step={step} field={step.field} />;
      default:
        return null;
    }
  }

  if (!field) {
    return null;
  }

  const frameClasses = [styles.scrollFrame, topShadow && styles.topShadow, bottomShadow && styles.bottomShadow].filter(Boolean).join(' ');

  return (
    <div className={frameClasses}>
      <div className={styles.scrollArea} ref={scrollRef}>
        {field}
      </div>
    </div>
  );
}
